import { render, staticRenderFns } from "./ExpenseTracking.vue?vue&type=template&id=5631af41&scoped=true&"
import script from "./ExpenseTracking.vue?vue&type=script&lang=js&"
export * from "./ExpenseTracking.vue?vue&type=script&lang=js&"
import style0 from "./ExpenseTracking.vue?vue&type=style&index=0&id=5631af41&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5631af41",
  null
  
)

export default component.exports